export default __webpack_public_path__ + "static/email-example-dfbd631229d83018bc9fcaba5fffd852.png";